import chrom from "../assets/mark/chrom.webp";
import applelog from "../assets/mark/applelog.webp";
import micro from "../assets/mark/micro.webp";
import sams from "../assets/mark/sams.webp";
import sony from "../assets/mark/sony.webp";
import x96 from "../assets/mark/x96.webp";
import tosh from "../assets/mark/tosh.webp";
import phili from "../assets/mark/phili.webp";
import lonov from "../assets/mark/lonov.webp";
import formuller from "../assets/mark/formuller.webp";
import xbox from "../assets/mark/xbox.webp";
import amz from "../assets/mark/amz.webp";
import android from "../assets/mark/android.webp";
import sharp from "../assets/mark/sharp.webp";
import tcl from "../assets/mark/tcl.webp";
import lg from "../assets/mark/lg.webp";
import androidtv from "../assets/mark/androidtv.webp";
import firetv from "../assets/mark/firetv.webp";

import netflix from "../assets/channel/Netflix.png";
import canal from "../assets/channel/Canal+.png";
import dazn from "../assets/channel/DAZN.png";
import bein from "../assets/channel/Bein_Sports.png";

import SectionHeading from '../components/SectionHeading';
import LogoCard from '../components/LogoCard';
import Reveal from '../components/Reveal';
import { useLanguage } from '../i18n/LanguageContext';
import { deviceContent } from '../i18n/content/device';

const DEVICES = [
    { id: 1, image: chrom, name: "Chromecast" },
    { id: 2, image: applelog, name: "Apple TV" },
    { id: 3, image: micro, name: "Microsoft" },
    { id: 4, image: sams, name: "Samsung" },
    { id: 5, image: sony, name: "Sony" },
    { id: 6, image: x96, name: "X96" },
    { id: 7, image: tosh, name: "Toshiba" },
    { id: 8, image: phili, name: "Philips" },
    { id: 9, image: lonov, name: "Lenovo" },
    { id: 10, image: formuller, name: "Formuler" },
    { id: 11, image: xbox, name: "Xbox" },
    { id: 12, image: amz, name: "Amazon" },
    { id: 13, image: android, name: "Android" },
    { id: 14, image: sharp, name: "Sharp" },
    { id: 15, image: tcl, name: "TCL" },
    { id: 16, image: lg, name: "LG" },
    { id: 17, image: androidtv, name: "Android TV" },
    { id: 18, image: firetv, name: "Fire TV" },
];

export default function Device(){
    const { lang } = useLanguage();
    const c = deviceContent[lang];
    const half = Math.ceil(DEVICES.length / 2);
    const left = DEVICES.slice(0, half);
    const right = DEVICES.slice(half);

    return(
        <section className="section2 relative overflow-hidden" id="device" style={{backgroundColor: 'var(--bg-color)'}}>
            <div className="absolute inset-0 ambient-glow"></div>
            <div className="main-content relative">
                <Reveal className="mb-12">
                    <SectionHeading eyebrow={c.eyebrow} title={c.title} />
                </Reveal>

                <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(220px,320px)_1fr] gap-6 items-center">
                    <Reveal className="grid grid-cols-3 gap-3">
                        {left.map((device) => (
                            <LogoCard key={device.id} image={device.image} name={device.name} height="h-10 md:h-14" />
                        ))}
                    </Reveal>

                    {/* Central screen mockup */}
                    <Reveal delay={100} className="relative mx-auto w-full">
                        <div className="rounded-card-lg border border-line-strong bg-surface p-3 shadow-lg">
                            <div className="rounded-card-md overflow-hidden bg-black aspect-[4/3] relative flex items-center justify-center">
                                <div className="absolute inset-0 ambient-glow"></div>
                                <div className="relative grid grid-cols-2 gap-3 p-6">
                                    <div className="bg-white rounded-lg p-2 flex items-center justify-center h-12"><img src={netflix} alt="" className="max-h-full max-w-full object-contain" /></div>
                                    <div className="bg-white rounded-lg p-2 flex items-center justify-center h-12"><img src={canal} alt="" className="max-h-full max-w-full object-contain" /></div>
                                    <div className="bg-white rounded-lg p-2 flex items-center justify-center h-12"><img src={dazn} alt="" className="max-h-full max-w-full object-contain" /></div>
                                    <div className="bg-white rounded-lg p-2 flex items-center justify-center h-12"><img src={bein} alt="" className="max-h-full max-w-full object-contain" /></div>
                                </div>
                            </div>
                        </div>
                        {/* Stand */}
                        <div className="w-16 h-3 bg-surface border border-line-strong mx-auto rounded-b-md"></div>
                        <div className="w-28 h-1.5 bg-surface border border-line-strong mx-auto rounded-full"></div>
                    </Reveal>

                    <Reveal delay={180} className="grid grid-cols-3 gap-3">
                        {right.map((device) => (
                            <LogoCard key={device.id} image={device.image} name={device.name} height="h-10 md:h-14" />
                        ))}
                    </Reveal>
                </div>
            </div>
        </section>
    )
}
